import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthSignal } from '@xanadu/signal';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(
        private readonly authSignal: AuthSignal
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
        const authorizationHeader = request.headers.get('Authorization');

        if (!authorizationHeader) {
            const identity = this.authSignal.identity();

            if (identity && identity.token) {
                request = request.clone({
                    setHeaders: {
                        Authorization: `Bearer ${identity.token}`
                    }
                });
            }
        }

        return next.handle(request);
    }
}
